/**
 * Runtime config from env. Use .env (never committed) or Amplify build env.
 * In local dev, when VITE_API_PROXY_TARGET is set we use /api so the Vite proxy
 * forwards to the API (avoids CORS). Production uses VITE_API_BASE_URL.
 */
const getEnv = (key: keyof ImportMetaEnv): string => (import.meta.env[key] ?? '') as string;
const trimEnv = (key: keyof ImportMetaEnv): string => getEnv(key).trim();

const explicitApiUrl = trimEnv('VITE_API_BASE_URL') || '';
const proxyTarget = trimEnv('VITE_API_PROXY_TARGET') || '';
const inDev = typeof import.meta !== 'undefined' && !!import.meta.env?.DEV;
const useProxyInDev = inDev && !!proxyTarget && typeof window !== 'undefined';

export const config = {
  apiBaseUrl: useProxyInDev ? `${window.location.origin}/api` : explicitApiUrl,
  /** Required for dashboard: sign-in and admin API use Cognito. Set after first CDK deploy (outputs). */
  cognitoUserPoolId: trimEnv('VITE_COGNITO_USER_POOL_ID') || '',
  cognitoClientId: trimEnv('VITE_COGNITO_CLIENT_ID') || '',
  /** Optional: Cognito Hosted UI domain (e.g. https://your-domain.auth.region.amazoncognito.com) for federated sign-in (Google, etc.). */
  cognitoOAuthDomain: trimEnv('VITE_COGNITO_OAUTH_DOMAIN') || '',
  /** Callback URL after Hosted UI sign-in (e.g. https://yourapp.com/auth/callback or http://localhost:5173/auth/callback). */
  cognitoOAuthRedirectSignIn: trimEnv('VITE_COGNITO_OAUTH_REDIRECT_SIGN_IN') || (typeof window !== 'undefined' ? `${window.location.origin}/auth/callback` : ''),
};
